module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_5minlab.6f61c1d58c52495f3eb2d9d9871fc079.png";